import { schema } from 'normalizr';
import moment from 'moment-timezone';


export const collectStatusMessages = (position) => {
  const statusMessages = [];
  const daysFinishingSoon = moment(position.finishTime).diff(moment(), 'days');
  const defaultMessage = `Weployee ending in ${daysFinishingSoon} ${daysFinishingSoon > 1 ? 'days' : 'day'}`;

  if (position.hasPendingExtensionRequests) {
    statusMessages.push('Extension requested');
  } else if (position.isFinishingSoon && position.extendable) {
    if (position.belongsToCurrentUser) {
      statusMessages.push(`${defaultMessage}. Extend?`);
    } else {
      statusMessages.push(`${defaultMessage}`);
    }
  }

  return statusMessages;
};

export const weployee = new schema.Entity('weployees', {}, {
  processStrategy: (value) => {
    const newValue = { ...value };
    const { contactDetails } = newValue;
    delete newValue.contactDetails;

    return {
      ...newValue,
      ...contactDetails,
    };
  },
});

export const timesheet = new schema.Entity('timesheets');

export const position = new schema.Entity('positions', {
  weployee,
  timesheets: [timesheet],
}, {
  processStrategy: (value, parent) => {
    const { belongsToCurrentUser } = parent;
    const newValue = { ...value, belongsToCurrentUser };

    return {
      ...newValue,
      statusMessages: collectStatusMessages(newValue),
    };
  },
});

export const jobs = new schema.Entity('jobs', {
  positions: [position],
}, {
  processStrategy: (value) => {
    const newValue = { ...value };
    const { location, latestPositionFinishTime } = newValue;
    delete newValue.location;
    delete newValue.latestPositionFinishTime;

    return {
      ...newValue,
      ...location,
      finishTime: latestPositionFinishTime,
    };
  },
});
